module.exports = __webpack_public_path__ + "img/article4_7.7d61e83f.jpg";